import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=d2371478&scoped=true&"
import script from "./LoginForm.vue?vue&type=script&lang=ts&"
export * from "./LoginForm.vue?vue&type=script&lang=ts&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=d2371478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2371478",
  null
  
)

export default component.exports